import {
  Col,
  Row,
} from "react-bootstrap";
import { GenericToggleGroup } from "../../components/ofertas/GenericToggleGroup";
import { TYPE_OFERTA_OPTIONS } from "../../utils/constants/tarifas";
import { SelectInput } from "../../components/inputs/Inputs";
import { Controller } from "react-hook-form";

export const TypeOfertaSection = ({
  control,
  errors,
  params,
  typeOferta,
  loadingSubtypes,
  sub_types_offer_options,
  isRestrictedCallAgent,
}) => {
  // Opcions efectives del selector: si és CallAgent restringit, només es permet "Contrato Nuevo".
  // { value: "simple", label: "Contrato Nuevo" },
  // { value: "renovacion", label: "Renovación" }
  const typeOfertaOptions = isRestrictedCallAgent
    ? TYPE_OFERTA_OPTIONS.filter((option) => option.value === "simple")
    : TYPE_OFERTA_OPTIONS;

  return (
    <div className="bg-light p-4 rounded-4 border border-light mb-4">
    <Row className="g-3">
      <Col xs={12}>
        <h5 className="fw-bold text-secondary mb-3">Tipo de Oferta</h5>
      </Col>

      <Col xs={12}>
        <div className="mb-3">
          <label className="text-muted small fw-bold text-uppercase mb-2">Selección de Proceso</label>
          <GenericToggleGroup
            control={control}
            errors={errors}
            disabled={!!params.oferta_id}
            name="type_oferta"
            options={typeOfertaOptions}
          />
        </div>
      </Col>

      <Col xs={12}>
        <Controller
          control={control}
          name="sub_type_offer"
          render={({ field }) => (
            <div className="select-wrapper">
              <label className="text-muted small fw-bold text-uppercase mb-2">Subtipo de oferta</label>
              <SelectInput
                {...field}
                noFloating={true}
                error={errors.sub_type_offer?.message}
                disabled={!typeOferta || loadingSubtypes}
                className="bg-white shadow-sm"
              >
                {loadingSubtypes ? (
                  <option>Cargando subtipos...</option>
                ) : (
                  <>
                    <option value=""></option>
                    {sub_types_offer_options.map((to) => (
                      <option key={to.id} value={to.id}>
                        {to.name}
                      </option>
                    ))}
                  </>
                )}
              </SelectInput>
            </div>
          )}
        />
      </Col>
    </Row>
  </div>
  );
};